import { render, staticRenderFns } from "./DetailProcessus.vue?vue&type=template&id=c6c3bf7e&scoped=true&"
import script from "./DetailProcessus.vue?vue&type=script&lang=js&"
export * from "./DetailProcessus.vue?vue&type=script&lang=js&"
import style0 from "./DetailProcessus.vue?vue&type=style&index=0&id=c6c3bf7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c3bf7e",
  null
  
)

export default component.exports